import { useCallback, useEffect, useState } from 'react';

// Hooks
import useFetchIntervalData from '../../../../../packages/hooks/useFetchIntervalData';
import useSubscriptionClick from '../../../../../packages/hooks/useSubscriptionClick';

// Utils
import { getTeamInformation } from '../../../../../packages/services/football/team';
import { normalizeTeamInformation } from '../../normalizers/team/normalizeTeamInformationResponseData';

// Types
import { IGeneralSubscriberInfo } from '../../../../../packages/constants/subscribeTypes';
import { ITeamConfig, SDKOptions } from '../../../../../packages/types';
import { TeamInformation } from '../../types';

interface IUseTeamInformationArgs extends IGeneralSubscriberInfo {
  dataRefreshTime?: ITeamConfig['dataRefreshTime'];
  dataTeam?: ITeamConfig['dataTeam'];
  sdkOptions: SDKOptions;
  dataLabels?: ITeamConfig['dataLabels'];
  dataEntityLinks?: ITeamConfig['dataEntityLinks'];
}

export default function useTeamInformation({
  dataRefreshTime,
  dataWidgetId,
  dataWidgetSport,
  subscribers,
  dataWidgetCuid,
  dataTeam,
  sdkOptions,
  dataEntityLinks,
  dataLabels,
}: IUseTeamInformationArgs) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [teamInformation, setTeamInformation] = useState<TeamInformation>();

  const fetchTeamInformation = useCallback(
    (manageLoader: boolean) => {
      manageLoader && setLoading(true);
      if (dataTeam) {
        getTeamInformation({ id: dataTeam, sdkOptions })
          .then((information) => {
            manageLoader && setLoading(false);
            const teamInformation = normalizeTeamInformation({
              information,
              dataLabels,
              dataEntityLinks,
            });
            setTeamInformation(teamInformation);
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      }
    },
    [dataTeam],
  );

  useFetchIntervalData(fetchTeamInformation, dataRefreshTime);

  useEffect(() => {
    fetchTeamInformation(true);
  }, [fetchTeamInformation]);

  return {
    widgetData: { teamInformation, isLoading },
    handleClick: useSubscriptionClick({ dataWidgetId, dataWidgetSport, dataWidgetCuid, subscribers }),
  };
}
